import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceStock } from 'src/app/service-stock.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-gotx-popup',
  templateUrl: './gotx-popup.component.html',
  styleUrls: ['./gotx-popup.component.css']
})
export class GotxPopupComponent implements OnInit {

  @Input('params') params: any;
  @Input('activeModal') activeModal: NgbActiveModal;

  constructor(private router: Router, private services: ServiceStock) { }

  ngOnInit() {
    // console.log("params", this.params);
  }

  buttonClick(idx) {
    // console.log(event);
    switch (this.params.buttonAction[idx]) {
      case "reload":
        this.services.modal.dismissAll();
        this.router.navigate(['/login']);
        break;
      case "ok":
        this.activeModal.close('ok');
        break;
      case "close":
        this.activeModal.close('close');
        break;
      case "logout":
        this.services.logout();
        break;

    }
  }

}
